'use client'
import { useState } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'
import Logo from './Logo'
import { useLocation, useNavigate } from "react-router-dom";
import QuickScan from './home/QuickScan';

const navigation = [
    { name: 'Marketplace', href: '/marketplace', description: 'Browse shops & suppliers', icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shopping-bag w-[16px] h-[16px] text-[#ff5323]"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path><path d="M3 6h18"></path><path d="M16 10a4 4 0 0 1-8 0"></path></svg> },
    { name: 'About', href: '/about', description: 'Learn how it works', icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-info w-[16px] h-[16px] text-[#53585f]"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4"></path><path d="M12 8h.01"></path></svg> },
    { name: 'Contact', href: '/contact', description: 'Get in touch', icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-mail w-[16px] h-[16px] text-[#53585f]"><rect width="20" height="16" x="2" y="4" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg> },
    { name: 'List Your Business', href: '/onboarding/plan', description: 'Pick your plan', icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-store w-[16px] h-[16px] text-[#ff5323]"><path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7"></path><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path><path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4"></path><path d="M2 7h20"></path><path d="M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7"></path></svg> },
    { name: 'Store Login', href: '/shop-login', description: 'Manage your shop', icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-log-in w-[16px] h-[16px] text-[#53585f]"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" x2="3" y1="12" y2="12"></line></svg> },

]

const NavBar = ({ isLoging, onBoarding, step }) => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [isQuickScanOpen, setIsQuickScanOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const isHomePage = location.pathname === '/';

    return (
        <header className="bg-white border-b border-[#e4e5e7] sticky top-0 z-30">
            <nav aria-label="Global" className="max-w-[1200px] mx-auto px-[16px] md:px-[40px] py-[14px] flex items-center justify-between">
                <Logo />
                {!isLoging && !onBoarding && (
                    <div className="flex items-center lg:hidden gap-2">
                        {isHomePage && (
                            <button
                                onClick={() => setIsQuickScanOpen(true)}
                                className="flex items-center gap-[6px] px-[14px] h-[38px] rounded-[10px] border border-[#e4e5e7] font-semibold text-[13px] text-[#212326] hover:bg-[#f4f5f6] transition-colors cursor-pointer bg-transparent"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-scan-line w-[14px] h-[14px] text-[#ff5323]">
                                    <path d="M3 7V5a2 2 0 0 1 2-2h2"></path><path d="M17 3h2a2 2 0 0 1 2 2v2"></path><path d="M21 17v2a2 2 0 0 1-2 2h-2"></path><path d="M7 21H5a2 2 0 0 1-2-2v-2"></path><path d="M7 12h10"></path>
                                </svg>
                                QuickScan
                            </button>
                        )}

                        <button className="flex items-center justify-center w-[38px] h-[38px] rounded-[10px] border border-[#e4e5e7] hover:bg-[#f4f5f6] transition-colors cursor-pointer bg-transparent"
                            onClick={() => setMobileMenuOpen(true)}

                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-menu w-[18px] h-[18px] text-[#212326]">
                                <line x1="4" x2="20" y1="12" y2="12"></line><line x1="4" x2="20" y1="6" y2="6"></line><line x1="4" x2="20" y1="18" y2="18"></line>
                            </svg>
                        </button>
                    </div>
                )}

                <div className={`lg:flex ${isLoging ? 'flex' : onBoarding ? 'flex' : 'hidden'} items-center gap-2`} >
                    {isLoging ? (
                        <button
                            className="font-semibold text-[13px] text-[#ff5323] hover:underline no-underline"
                            onClick={() => navigate("/onboarding/plan")}
                            data-discover="true"
                        >
                            Create an account
                        </button>
                    ) : onBoarding ? (
                        <div className="flex items-center gap-[12px]">
                            <span className="text-[13px] font-semibold text-[#9298a0]">Step {step || "1"} of 8</span>
                            <button
                                className="px-[14px] py-[8px] rounded-[10px] border border-[#e4e5e7] font-semibold text-[13px] text-[#212326] hover:bg-[#f4f5f6] transition-colors no-underline"
                                onClick={() => navigate("/")}
                            >
                                Exit
                            </button>
                        </div>

                    ) : (
                        <>
                            {navigation
                                .filter(
                                    item =>
                                        item.name !== 'List Your Business' &&
                                        item.name !== 'Store Login'
                                    // && !(item.name === 'Quick Scan' && !isHomePage)
                                )
                                .map((item) => {
                                    const isActive = location.pathname === item.href;

                                    return (
                                        <button
                                            key={item.name}
                                            onClick={() => navigate(item.href)}
                                            target={item.target}
                                            rel={item.target === '_blank' ? 'noreferrer' : undefined}
                                            className={`flex items-center px-[14px] py-[8px] rounded-[10px] font-semibold text-[13px] transition-colors no-underline
                    ${isActive
                                                    ? 'text-[#ff5323] bg-[#fff5f2]'
                                                    : 'text-[#53585f] hover:bg-[#f4f5f6]'
                                                }`}
                                        >
                                            {item.name}
                                        </button>
                                    );
                                })}



                            <button
                                onClick={() => setIsQuickScanOpen(true)}
                                className="flex items-center px-[14px] py-[8px] rounded-[10px] font-semibold text-[13px] transition-colors no-underline text-[#53585f] hover:bg-[#f4f5f6]"
                            >
                                Quick Scan
                            </button>
                            <>
                                <button
                                    onClick={() => navigate("/onboarding/plan")}
                                    className="flex items-center px-[14px] py-[8px] rounded-[10px] bg-[#ff5323] text-white font-semibold text-[13px] hover:bg-[#e64a1f] transition-colors no-underline"
                                >
                                    List Your Business
                                </button>
                                <button
                                    onClick={() => navigate("/shop-login")}
                                    className="flex items-center px-[14px] py-[8px] rounded-[10px] border border-[#e4e5e7] font-semibold text-[13px] text-[#212326] hover:bg-[#f4f5f6] transition-colors no-underline"
                                >
                                    Store Login
                                </button>
                            </>

                        </>
                    )}

                </div>

            </nav >
            <Dialog
                open={mobileMenuOpen}
                onClose={setMobileMenuOpen}
                className="relative z-50 lg:hidden"
            >
                {/* Backdrop */}
                <div className="fixed inset-0 bg-black/20" />

                {/* Panel */}
                <DialogPanel
                    className="fixed top-16 right-4 w-[220px] rounded-[14px] bg-white border border-[#e4e5e7] shadow-[0px_8px_24px_rgba(0,0,0,0.12)]"
                >
                    <div className="mt-0 flow-root">
                        <div className="-my-0 divide-y divide-gray-500/10">
                            <div className="space-y-2">
                                {navigation
                                    .filter(item => item.name !== 'Quick Scan')
                                    .map((item, index) => (
                                        <a
                                            key={item.name}
                                            href={item.href}
                                            className="flex items-center gap-[12px] px-[16px] py-[14px] font-semibold text-[14px] text-[#212326] hover:bg-[#f4f5f6] transition-colors no-underline"
                                            target={item.target}
                                            rel={item.target === '_blank' ? 'noreferrer' : undefined}
                                        >
                                            <div
                                                className={`w-[32px] h-[32px] rounded-[8px] flex items-center justify-center shrink-0 ${index === 0 || index === 3
                                                    ? 'bg-[#fff0ec]'
                                                    : 'bg-[#f4f5f6]'
                                                    }`}
                                            >
                                                {item.icon}
                                            </div>
                                            <div><p className="font-semibold text-[14px] text-[#212326]">{item.name}</p>
                                                <p className="font-medium text-[11px] text-[#9298a0]">{item.description}</p>
                                            </div>

                                        </a>
                                    ))}
                            </div>

                        </div>
                    </div>
                </DialogPanel>
            </Dialog>

            {isQuickScanOpen && (
                <QuickScan isQuickScanOpen={isQuickScanOpen} onClose={() => setIsQuickScanOpen(false)} />
            )}
        </header >
    )
}

export default NavBar

